<template>
    <ion-alert
        :is-open="isOpenRef"
        cssClass = 'reason-code-alert'
        ref="alert"
        :header="header"
        :sub-header="subtitle"
        :message="message"
        :buttons="buttons"
        @onDidDismiss="dismissed($event)"
        :inputs="options"
    ></ion-alert>
</template>

<script>
import {IonAlert, alertController} from '@ionic/vue';
import EventBus from "@/EventBus";
import _ from 'lodash';
import {ref} from 'vue';
export default {
    inject: ['$http', '$validationAlert', '$toast'],
    props: ['subtitle', 'message', 'header', 'group'],
    name: "FailedPickCountReasonAlert",
    components: {IonAlert},
    computed: {
        options() {
            return _.map(this.rawOptions, option => {
                return {
                    type: 'radio',
                    label: option.name,
                    value: option
                }
            });
        },
        buttons() {
            return [{
                text: 'Cancel',
                role: 'cancel'
            }, {
                text: 'Ok',
                handler: (reason) => {
                    if (reason.offers_input) {
                        this.setOpen(false);
                        this.presentMoreDetailsAlert(reason);
                    } else {
                        this.$emit('submitted', {
                            reason: reason
                        });
                    }
                }
            }]
        }
    },
    data() {
        return {
            rawOptions: []
        }
    },
    methods: {
        dismissed(event) {
            this.setOpen(false);
        },
        presentMoreDetailsAlert(reason) {
            alertController.create({
                header: reason.name,
                subHeader: 'The selected reason code needs more information',
                inputs: [{
                    type: 'textarea',
                    name: 'reason_comment',
                    placeholder: 'Please provide as much information as possible'
                }],
                buttons: [{
                    text: 'Cancel',
                    role: 'cancel'
                }, {
                    text: 'Save',
                    handler: (value) => {
                        if (reason.requires_input && value.reason_comment.length < 2) {
                            this.$toast.danger("You must provide more information");
                            return false;
                        }
                        this.$emit('submitted', {
                            reason: reason,
                            comment: value.reason_comment
                        });
                    }
                }]
            }).then(alert => {
                alert.present();
            });
        },
        fetchReasons(success) {
            EventBus().emitter.emit('loading', true);
            this.$http
                .get('/api/reason-codes', {
                    params: {all: true, 'group.code': this.group, orderBy: 'name'}
                })
                .then(response => {
                    this.rawOptions = response.data.items;
                    success.apply(this);
                })
                .catch(error => {
                    this.$validationErrors.alert(error);
                })
                .finally(() => {
                    EventBus().emitter.emit('loading', false);
                });
        },
        present() {
            this.fetchReasons(() => {
                this.setOpen(true);
            });
        }
    },
    setup() {
        const isOpenRef = ref(false);
        const setOpen = (state) => isOpenRef.value = state;
        return {
            isOpenRef, setOpen
        }
    }
}
</script>
<style>
    /* Can't do scoped here because ion-alert appears at the root of the dom */
    ion-alert.reason-code-alert .alert-radio-label {
        white-space: normal !important;
        overflow: inherit;
    }
</style>
